import React, { ReactNode, useCallback, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { VscTriangleDown } from "react-icons/vsc";
import Label from "./Label";
import Modal from "./Modal";
import { colors } from "src/styles/theme";
import { useStopBackScroll } from "src/hooks";
import { MdOutlineRadioButtonUnchecked, MdOutlineRadioButtonChecked } from "react-icons/md";

export function usePopupSelectV2(args?: { defaultSelectIds?: number[] }) {
  // TODO: useModal hook 으로 리팩토링

  const [isPopupShown, setIsPopupShown] = useState(false);
  const [activeIds, setActiveIds] = useState<number[]>([]);

  const [activeIdsToReturn, setActiveIdsToReturn] = useState<number[]>([]);
  const reset = () => {
    setActiveIds([]);
  };
  const propsToInject = {
    isPopupShown,
    setIsPopupShown,
    activeIdsToInject: activeIds,
    setActiveIdsToInject: setActiveIds,
    activeIdsToReturn,
    setActiveIdsToReturn,
  };

  useEffect(() => {
    if (args?.defaultSelectIds?.length) {
      setActiveIdsToReturn([...(args?.defaultSelectIds || [])]);
      setActiveIds([...(args?.defaultSelectIds || [])]);
    }
  }, [JSON.stringify(args?.defaultSelectIds)]);

  const PopupSelect = useCallback(
    (props: {
      items: { id: number; name: string }[];
      placeholder?: string;
      $resultCenter?: boolean;
      $resultFullWidth?: boolean;
      label?: string;
      isHiddenLabel?: boolean;
      inputId?: string;
      tabIndex?: number;
      boldLabel?: boolean;
      size?: "sm" | "md";
      isEssential?: boolean;
      multiple?: boolean;
      hidden?: boolean;
      activeIdsToInject: number[];
      setActiveIdsToInject: React.Dispatch<React.SetStateAction<number[]>>;
      activeIdsToReturn: number[];
      setActiveIdsToReturn: React.Dispatch<React.SetStateAction<number[]>>;
      onSubmit?: (activeObejcts: any[], isUnSelect?: boolean) => any;
      // activeIds: any;
      // setActiveIds: any;
    }) => {
      return (
        <>
          <Container
            className=""
            onClick={() => setIsPopupShown(true)}
            $hidden={props.hidden}
            $size={props.size || "md"}
            $resultCenter={props.$resultCenter || false}
            $resultFullWidth={props.$resultFullWidth || false}
          >
            {props.label && !props.isHiddenLabel && (
              <Label
                content={props.label}
                isEssential={props.isEssential}
                className={`${props.boldLabel ? "bold" : ""} mb-1`}
              />
            )}
            <div
              className={`content-main input-box-type d-flex jc-sb ai-c ${props.size}`}
              id={props.inputId || `${Date.now()}-group-c-s`}
              tabIndex={props.tabIndex}
            >
              {(props.activeIdsToReturn?.length || 0) < 1 ? (
                <>
                  <div className="showing placeholder">{props.placeholder}</div>
                </>
              ) : (
                <>
                  {props.multiple ? (
                    <>
                      {props.items
                        .filter((item) => props.activeIdsToReturn?.includes(item.id))
                        .map((i) => i.name)
                        .join(", ")}
                    </>
                  ) : (
                    <>
                      <div className="showing">
                        {(() => {
                          const seleted = props.items.find(
                            (i) => i.id === props.activeIdsToReturn?.[0]
                          )?.name;
                          if (!seleted) {
                            return " - ";
                          }
                          return seleted;
                        })()}
                      </div>
                    </>
                  )}
                </>
              )}
              <VscTriangleDown
                className="triangle"
                size={props.size === "sm" ? 12 : 16}
                color="black"
              />
            </div>
          </Container>
          {isPopupShown && (
            <Inner>
              <Modal
                title={props.label ? props.label : null}
                btnType={props.multiple ? "confirm" : "none"}
                setModalState={setIsPopupShown}
                onConfirm={() => {
                  props.setActiveIdsToReturn(props.activeIdsToInject);
                  if (props.onSubmit) {
                    props.onSubmit(
                      props.items.filter((item) => {
                        return props.activeIdsToInject?.some((id: any) => id === item.id);
                      })
                    );
                  }
                }}
                content={
                  <ModalContentContainer>
                    <ul>
                      {props.items.map((item) => {
                        return (
                          <li
                            onClick={() => {
                              if (props.activeIdsToInject?.includes(item.id)) {
                                // 선택해제
                                if (props.onSubmit) {
                                  props.onSubmit([item.id], true);
                                }
                                props.setActiveIdsToInject((aIds: any) => {
                                  return aIds.filter((aid: any) => aid !== item.id);
                                });

                                return;
                              }
                              if (props.multiple) {
                                props.setActiveIdsToInject((aids: any) => [...aids, item.id]);
                                if (props.onSubmit) {
                                  //TODO: 로직검증
                                  props.onSubmit([...activeIds, item.id]);
                                }
                                return;
                              } else {
                                props.setActiveIdsToInject([item.id]);
                                props.setActiveIdsToReturn([item.id]);
                                if (props.onSubmit) {
                                  props.onSubmit([item.id]);
                                }
                                setTimeout(() => {
                                  setIsPopupShown(false);
                                }, 100);
                              }
                            }}
                            key={item.id}
                            className={
                              props.activeIdsToInject?.includes(item.id)
                                ? "active-true"
                                : "active-false"
                            }
                          >
                            {props.activeIdsToInject?.includes(item.id) ? (
                              <MdOutlineRadioButtonChecked size={25} />
                            ) : (
                              <MdOutlineRadioButtonUnchecked size={25} />
                            )}
                            <div>{item.name}</div>
                          </li>
                        );
                      })}
                    </ul>
                  </ModalContentContainer>
                }
              ></Modal>
            </Inner>
          )}
        </>
      );
    },
    [isPopupShown]
  );
  return { PopupSelect, propsToInject, activeIds: activeIdsToReturn, reset };
}

const Container = styled.div<{
  $hidden?: boolean;
  $size?: "sm" | "md";
  $resultCenter: boolean;
  $resultFullWidth: boolean;
}>`
  ${(p) => {
    if (p.$hidden) {
      return css`
        display: none;
      `;
    }
  }}

  ${(p) =>
    p.$resultFullWidth
      ? css`
          width: 100%;
        `
      : ""}

  cursor: pointer;
  label {
    display: inline-block;
  }
  .content-main {
    ${(p) => {
      switch (p.$size) {
        case "sm": {
          return "padding: 0px 2px";
        }
        case "md":
        default: {
          return "";
        }
      }
    }};
  }
  .showing {
    ${(p) => {
      if (p.$resultCenter) {
        return css`
          margin: 0 auto;
        `;
      }
    }}
    font-size: ${(p) => {
      switch (p.$size) {
        case "sm": {
          return "12px !important";
        }
        case "md":
        default: {
          return "16px";
        }
      }
    }};
    &.placeholder {
      color: ${colors.gray.first};
      font-size: ${(p) => {
        switch (p.$size) {
          case "sm": {
            return "10px";
          }
          case "md":

          default: {
            return "12px";
          }
        }
      }};
    }
  }
  .triangle {
  }
`;
const Inner = (props: { children: ReactNode }) => {
  useStopBackScroll();
  return <>{props.children}</>;
};

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
  h4 {
    padding: 10px;
  }

  ul {
    max-height: 70vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    transition: all 0.15s;

    li {
      cursor: pointer;
      /* padding: 10px 0px; */
      padding: 10px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      gap: 15px;
      font-size: 18px;
      transition: all 0.15s;
      svg {
        color: ${colors.gray.first};
        transition: all 0.15s;
      }
      &.active-true {
        svg {
          color: ${colors.green.first};
        }
      }
    }
  }
`;
